import { render, staticRenderFns } from "./relation-number.vue?vue&type=template&id=eae827ba&scoped=true"
import script from "./relation-number.vue?vue&type=script&lang=js"
export * from "./relation-number.vue?vue&type=script&lang=js"
import style0 from "./relation-number.vue?vue&type=style&index=0&id=eae827ba&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eae827ba",
  null
  
)

export default component.exports